var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cartTotalPrice"},[_c('span',[_vm._v("Сумма в корзине:")]),_vm._v(" "),_c('span',{staticClass:"notranslate"},[_vm._v(_vm._s(_setup.totalSum)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_setup.props.currencyIcon)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }